// src/pages/DynamicPage.jsx
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import ApiService from "../services/ApiService";

const DynamicPage = () => {
  const { slug } = useParams(); // Get slug from URL
  const [pageData, setPageData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (slug) {
      fetchPageContent(slug);
    }
  }, [slug]);

  const fetchPageContent = async (slugValue) => {
    try {
      const response = await ApiService.request({
        method: "GET",
        url: `/getPage/${slugValue}`,
      });

      if (response.data?.status) {
        setPageData(response.data.data.page);
      }
    } catch (error) {
      console.error("Error fetching page:", error);
    } finally {
      setIsLoading(false);
    }
  };

  if (isLoading) return  <div
  className="inter-font d-flex justify-content-center align-items-center"
  style={{ height: "100vh" }}
>
  <h4>Loading...</h4>
</div>;
  if (!pageData) return 
  <div
    className="inter-font d-flex justify-content-center align-items-center"
    style={{ height: "100vh" }}
  >
    <h4>No content found.</h4>
  </div>;

  return (
    <div className="container my-4">
      <div dangerouslySetInnerHTML={{ __html: pageData.content }} />
    </div>
  );
};

export default DynamicPage;
